import { render, staticRenderFns } from "./changelist.vue?vue&type=template&id=4e9d7c77&scoped=true"
import script from "./changelist.vue?vue&type=script&lang=js"
export * from "./changelist.vue?vue&type=script&lang=js"
import style0 from "./changelist.vue?vue&type=style&index=0&id=4e9d7c77&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9d7c77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9d7c77')) {
      api.createRecord('4e9d7c77', component.options)
    } else {
      api.reload('4e9d7c77', component.options)
    }
    module.hot.accept("./changelist.vue?vue&type=template&id=4e9d7c77&scoped=true", function () {
      api.rerender('4e9d7c77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parts/changelist.vue"
export default component.exports